"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emporiModule = void 0;
/**
 * Expose and combine given object to the global Empori module object.
 *
 * @param eventName Event name to trigger on document.
 * @param obj Object to combine and expose.
 */
function emporiModule(eventName, obj) {
    const win = window;
    const exposedObj = Object.assign(win.empori || {}, obj);
    win.empori = exposedObj;
    const event = document.createEvent('Event');
    event.initEvent(eventName, false, false);
    event.empori = exposedObj;
    document.dispatchEvent(event);
}
exports.emporiModule = emporiModule;
//# sourceMappingURL=index.js.map